import { render, staticRenderFns } from "./SchoolListItem.vue?vue&type=template&id=a4ef6622&scoped=true&lang=pug&"
import script from "./SchoolListItem.vue?vue&type=script&lang=js&"
export * from "./SchoolListItem.vue?vue&type=script&lang=js&"
import style0 from "./SchoolListItem.vue?vue&type=style&index=0&id=a4ef6622&lang=scss&scoped=true&"
import style1 from "./SchoolListItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ef6622",
  null
  
)

export default component.exports